import { NavLink } from "react-router";
import { LayoutDashboard, Radio, TrendingUp, Rss, Settings2 } from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/signals", label: "Signals", icon: Radio, end: false },
  { to: "/trades", label: "Trades", icon: TrendingUp, end: false },
  { to: "/channels", label: "Channels", icon: Rss, end: false },
  { to: "/settings", label: "Settings", icon: Settings2, end: false },
];

/**
 * Fixed to the bottom, thumb reach on a phone. `pb-[env(safe-area-inset-bottom)]` keeps it
 * clear of a gesture bar — §21's "safe-area insets respected" checkpoint.
 */
export function BottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur">
      <div className="mx-auto flex max-w-lg items-stretch justify-around">
        {ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "flex min-w-[64px] flex-col items-center gap-1 px-3 py-2.5 text-xs",
                isActive ? "text-primary" : "text-muted-foreground",
              )
            }
          >
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
